import { Skeleton } from "@/components/ui/skeleton";
import { Button } from "@/components/ui/button";
import { AlertTriangle, RefreshCw, Inbox } from "lucide-react";

export const CardsSkeleton = ({ count = 6, className = "" }) => (
  <div className={`grid gap-6 sm:grid-cols-2 lg:grid-cols-3 ${className}`} data-testid="loading-skeleton">
    {Array.from({ length: count }).map((_, i) => (
      <div key={i} className="card-solid p-6">
        <Skeleton className="h-11 w-11 rounded-xl" />
        <Skeleton className="mt-5 h-5 w-2/3" />
        <Skeleton className="mt-3 h-4 w-full" />
        <Skeleton className="mt-2 h-4 w-5/6" />
      </div>
    ))}
  </div>
);

export const ErrorState = ({ message = "We couldn't load this content.", onRetry }) => (
  <div className="card-solid flex flex-col items-center gap-3 p-10 text-center" role="alert" data-testid="error-state">
    <AlertTriangle className="h-8 w-8 text-primary" />
    <p className="text-sm text-muted-foreground">{message}</p>
    {onRetry && <Button variant="outline" className="rounded-xl bg-white" onClick={onRetry} data-testid="error-retry-button"><RefreshCw className="h-4 w-4" /> Try again</Button>}
  </div>
);

export const EmptyState = ({ title = "Nothing here yet", text = "", action }) => (
  <div className="card-solid flex flex-col items-center gap-3 p-10 text-center" data-testid="empty-state">
    <Inbox className="h-8 w-8 text-muted-foreground" />
    <p className="font-medium">{title}</p>
    {text && <p className="max-w-sm text-sm text-muted-foreground">{text}</p>}
    {action}
  </div>
);
